export default "__VITE_ASSET__Dd9vtzZ4__"